import React from 'react'
import BGBlock from './BGBlock'
import { AiOutlineTag } from "@react-icons/all-files/ai/AiOutlineTag";
import PicCont from './PicCont';
import trust from '../public/Pictures/trust.png'
import percentage from '../public/Pictures/percentage.png'
import bill from '../public/Pictures/bill.png'
import analytics from '../public/Pictures/analytics.png'
import white from '../public/Pictures/model1_header.jpg'
import { IoIosArrowForward } from "@react-icons/all-files/io/IoIosArrowForward";

const B2BModelOne = ({summary }) => {

    return <section className='b2bModel' id='model1' >
      {!summary &&  <BGBlock src={white} >
            <div className="row">
                <AiOutlineTag /> <h2>White Label Partnership</h2>
            </div>
        </BGBlock>}
        <div className="partOne">
            <strong className="bTitle">{summary ? 'White Label Partnership' :'What is it?'}</strong>
            <p>

                We provide full AV service, from planning to execution, as our partner&apos;s <strong>internal AV division</strong>. <br /><br />
                We bill our partners directly to give them <strong>full control of their prices. Tiered <strong>discounts</strong> are directly given to the partner.</strong>. <br /><br />
                Our experts study the rooms to create <strong>customized AV packages</strong>. 
            </p>
        </div>
        <div className="partTwo">
            <strong className="bTitle">How does it work?</strong>
            <div className="row">
                <div className="col">
                    <div className="header">
                        <PicCont width={512} height={512} src={trust} />
                        <strong className="cTitle bold">White Label Service</strong>
                    </div>
                    <div className="divP">
                        <p>
                            Full white label service. Miami Sound Rental brand is not shown at any point. We adapt each touch point with the final client to the partner&apos;s brand (when needed or required) <br /><br />
                            Miami Sound Rental <strong>provides the service as part of the partner&apos;s team</strong>, planning and executing the event as if we are its internal AV Division. <br /><br />
                            We provide a white labeled estimates without showing our brand for our partner to share with the final client.
                        </p>
                    </div>
                </div>
                <div className="col">
                    <div className="header">
                        <PicCont width={512} height={512} src={bill} />
                        <strong className="cTitle bold">Retain Price Control</strong>
                    </div>
                    <div className="divP second">
                        <p>
                            We bill our partner, and the <strong> partner bills the final client</strong>. This way the partner retains <strong>full control of the prices</strong>, giving them the freedom to mark up the price as much as they see fit. <br /><br />
                            The brand Miami Sound Rental will never be known to the final client, so <strong>they will never be able to see what our standard prices are. </strong>
                        </p>
                    </div>
                </div>
                <div className="col">
                    <div className="header">
                        <PicCont width={512} height={512} src={analytics} />
                        <strong className="cTitle bold">Customized AV Solutions </strong>
                    </div>
                    <div className="divP">
                        <p>
                            Bespoke AV <strong>advisory service</strong>. We deploy our experts to the venue to craft <strong>customized packages for each room sizes and types</strong>. Our assessment provide a set of 6 to 10 tailor made packages that are delivered on an unbranded booklet the partner can show to their clients.<br /><br />
                            We put our <strong>tech platform and digital tools</strong> at the service of the partner: Online setup builder to edit or create new packages, equipment inventory updated in real time, quick quoting service, white labeled estimates, etc.
                        </p>
                    </div>
                </div>
                <div className="col">
                    <div className="header">
                        <PicCont width={512} height={512} src={percentage} />
                        <strong className="cTitle bold">Tiered Discount Schedule</strong>
                    </div>
                    <div className="divP last">
                        <p>
                            Progressive discount schedule based on volume of sales for the previous month:<br /><br />
                            <div className='discountRow'><strong>First Month:</strong><span className='discount'>20% Discount</span> </div><br />

                            <div className='discountRow headRow'><strong>After fist month:</strong><span className='discount'>Discount</span> </div><br />
                            <div className='discountRow'><span>Less than <strong>$10,000</strong> in sales:</span><span className='discount'>10%</span> </div>
                            <div className='discountRow'><span>Between <strong>$10,000</strong> and <strong>$30,000</strong> in sales:</span><span className='discount'>20%</span> </div>
                            <div className='discountRow'><span>More than <strong>$30,000</strong> in sales:</span><span className='discount'>30%</span> </div><br />
                            <strong>Discounts are directly applied to the venue</strong> in each service.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="partThree">
            <strong className="bTitle">How does it benefit your business?</strong>
            <div className='row'>
                <div className="point">
                    <strong className='pointTitle'><IoIosArrowForward /> We ensure reliable service through dedicated team.</strong>
                    <p>
                        Thanks to our data-driven service planning and delivery, we ensure flawless execution. We are the top-rated AV provider in South Florida. <strong> We guarantee the same quality of service for our partner&apos;s clients</strong>.
                    </p>
                </div>
                <div className="point ">
                    <strong className='pointTitle'><IoIosArrowForward /> Added value to our partner&apos;s brand</strong>
                    <p>
                        Our white label service model <strong> strengthens the client perception about our partners brand</strong>. Our team, productions and event service, are seen by the client as<strong> proprietary assets owned by the partner</strong>. Also all the content generated in events can be used and promoted by the partner as its own portfolio without having to mention us.
                    </p>
                </div>
                <div className="point">
                    <strong className='pointTitle'><IoIosArrowForward /> Sales and profit growth by financial benefits, higher margin control of prices </strong>
                    <p>
                        This model <strong>enhances our partners&quot; sales strategy</strong>. Having complete control of price visibility, they can modulate their sales approach to their choice, either translating discounts to the final client or increasing margin by keeping it.
                    </p>
                </div>
                <div className="point last">
                    <strong className='pointTitle'><IoIosArrowForward /> Easy to work with: Our technology and dedicated manager as a service </strong>
                    <p>
                        Our technology allows our partner to have an <strong>extremely agile quoting</strong> and booking process. No matter the complexity and size of the production, they are able to <strong>answer client requests in minutes</strong>, not days. We provide them access to our platform but also have a<strong> dedicated AV manager</strong> to assist them when needed.</p>
                </div>
            </div>
        </div>

    </section>
}

export default B2BModelOne